import type {
  UpdateProjectFileInput,
  UpdateProjectFileResponseBody,
} from "@imagine/ai-service/shared-types/route-types";
import { aiServiceFetch } from "./ai-service-client";
import { HttpError } from "./http-error";

type SaveArtifactFilesParams = {
  projectId: string;
  token: string;
  files: Array<UpdateProjectFileInput>;
};

export const saveArtifactFiles = async ({
  projectId,
  token,
  files,
}: SaveArtifactFilesParams): Promise<UpdateProjectFileResponseBody> => {
  if (!Array.isArray(files) || files.length === 0) {
    throw new Error("Files array must be non-empty");
  }

  const response = await aiServiceFetch(`/api/projects/${projectId}/files`, {
    method: "PUT",
    body: JSON.stringify({ files }),
  });

  if (!response.ok) {
    throw await HttpError.fromResponse(response);
  }

  return response.json();
};
